import { cn } from "@/lib/utils";
import {
  SearchIcon,
  FolderIcon,
  HomeIcon,
  ChartNoAxesColumn,
  Newspaper,
  Scan,
} from "lucide-react";
import { useMemo } from "react";
import { Link, NavLink } from "react-router-dom";

export function MobileNavBar() {
  const links = useMemo(() => {
    return [
      {
        name: "Home",
        href: "/",
        icon: <HomeIcon />,
      },
      {
        name: "Market",
        href: "/market",
        icon: <ChartNoAxesColumn />,
      },
      {
        name: "Binder",
        href: "/virtual-binder",
        icon: <FolderIcon />,
      },
      {
        name: "News",
        href: "/news",
        icon: <Newspaper />,
      },

      {
        name: "Scan",
        href: "/scan",
        icon: <Scan />,
      },
    ];
  }, []);

  return (
    <div className="fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 flex justify-around items-center p-4 pb-3 lg:hidden z-50">
      {links.map((link) => (
        <NavLink
          key={link.name}
          to={link.href}
          className={({ isActive }) =>
            cn("flex flex-col items-center text-sm gap-1 flex-1", {
              "text-primary": isActive,
            })
          }
        >
          {link.icon}
          {link.name}
        </NavLink>
      ))}
    </div>
  );
}
